import React from 'react';
import './About.css';

const About = () => {
  // Get team member image path
  const getTeamMemberImage = (name) => {
    return `${process.env.PUBLIC_URL || ''}/Teams/${name}.jpg`;
  };
  return (
    <div className="about-page">
      <section className="about-hero">
        <h1 className="about-title">About Us</h1>
        <p className="about-subtitle">Building Nepal's Future, One Project at a Time</p>
      </section>

      <section className="about-section">
        <div className="about-container">
          <div className="about-content">
            <div className="about-text">
              <h2 className="section-heading">Our Company</h2>
              <p>
                Karmatara Nirman Sewa Pvt. Ltd. has been building district highways and institutional 
                buildings for more than two decades. Our services span across whole Nepal from Udayapur 
                in East to Jajarkot in Far West, making us one of the most trusted construction 
                companies in the country.
              </p>
              <p>
                We excel in both government and private construction works, delivering projects that 
                combine history, culture, and modern engineering excellence. Our signature project, 
                the Sindhuligadhi War Museum built for Nepal Army, stands as a testament to our 
                commitment to quality and heritage preservation. This prestigious project now serves 
                as a tourist destination to more than 20,000 tourists each month.
              </p>
              <p>
                In addition to our construction services, we also rent earth moving equipment. Feel 
                free to reach out if you need excavators, backhoe loaders, dump trucks, tractors, 
                or other construction machinery. With a team of experienced professionals and skilled 
                workers, we take pride in contributing to Nepal's infrastructure development and 
                economic growth.
              </p>
            </div>
          </div>

          <div className="team-section">
            <h2 className="section-heading">Our Team</h2>
            <div className="team-grid">
              <div className="team-card">
                <img 
                  src={getTeamMemberImage('Ram Kumar Thapa')}
                  alt="Ram Kumar Thapa"
                  className="team-icon"
                  onError={(e) => {
                    console.error('Failed to load team member image');
                    e.target.style.display = 'none';
                  }}
                />
                <h3 className="team-name">Ram Kumar Thapa</h3>
                <p className="team-role">Managing Director / CEO</p>
              </div>
              <div className="team-card">
                <img 
                  src={getTeamMemberImage('Ashish Thapa')}
                  alt="Ashish Thapa"
                  className="team-icon"
                  onError={(e) => {
                    console.error('Failed to load team member image');
                    e.target.style.display = 'none';
                  }}
                />
                <h3 className="team-name">Ashish Thapa</h3>
                <p className="team-role">Civil and Structural Engineer</p>
              </div>
              <div className="team-card">
                <img 
                  src={getTeamMemberImage('Sasi Thapa')}
                  alt="Sasi Thapa"
                  className="team-icon"
                  onError={(e) => {
                    console.error('Failed to load team member image');
                    e.target.style.display = 'none';
                  }}
                />
                <h3 className="team-name">Sasi Thapa</h3>
                <p className="team-role">Civil And Highway Engineer</p>
              </div>
              <div className="team-card">
                <img 
                  src={getTeamMemberImage('Laxmi Karki')}
                  alt="Laxmi Karki"
                  className="team-icon"
                  onError={(e) => {
                    console.error('Failed to load team member image');
                    e.target.style.display = 'none';
                  }}
                />
                <h3 className="team-name">Laxmi Karki</h3>
                <p className="team-role">Senior Accountant</p>
              </div>
              <div className="team-card">
                <img 
                  src={getTeamMemberImage('Sujan Thapa')}
                  alt="Sujan Thapa"
                  className="team-icon"
                  onError={(e) => {
                    console.error('Failed to load team member image');
                    e.target.style.display = 'none';
                  }}
                />
                <h3 className="team-name">Sujan Thapa</h3>
                <p className="team-role">Junior Accountant</p>
              </div>
              <div className="team-card">
                <img 
                  src={getTeamMemberImage('Kishan Thapa')}
                  alt="Kishan Thapa"
                  className="team-icon"
                  onError={(e) => {
                    console.error('Failed to load team member image');
                    e.target.style.display = 'none';
                  }}
                />
                <h3 className="team-name">Kishan Thapa</h3>
                <p className="team-role">Civil and Structural Engineer</p>
              </div>
              <div className="team-card">
                <img 
                  src={getTeamMemberImage('Sushil Raut')}
                  alt="Sushil Raut"
                  className="team-icon"
                  onError={(e) => {
                    console.error('Failed to load team member image');
                    e.target.style.display = 'none';
                  }}
                />
                <h3 className="team-name">Sushil Raut</h3>
                <p className="team-role">IT Engineer</p>
              </div>
            </div>
          </div>

          <div className="values-section">
            <h2 className="section-heading">Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">⏱️</div>
                <h3>Timely Delivery</h3>
              </div>
              <div className="value-card">
                <div className="value-icon">💬</div>
                <h3>Effective Communication</h3>
              </div>
              <div className="value-card">
                <div className="value-icon">🏗️</div>
                <h3>Quality Work</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

